 <template>
  <o-field
    rootClass="tgbField"
    labelClass="tgbLabel"
    >
    <template slot="label">
      <span>{{ label }}</span>
      <small v-if="labelDescription" class="labelDescription">{{ labelDescription }}</small>
    </template>
    <o-select
      v-bind="{...$props, ...$attrs}"
      v-on="$listeners"
      @blur="$emit('blur')"
      @change="$emit('change')"
      v-model="innerModel"
      iconRightClass="tgbSelectIcon"
      >
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    </o-select>
  </o-field>
</template>

<script>
export default {
  name: 'TgbSelect',
  inheritAttrs: false,
  props: ['label', 'value', 'labelDescription'],
  computed: {
    innerModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
};
</script>

<style lang="scss">
  .tgbSelectIcon {
    padding-right: 10px;
    padding-top: 10px;
    cursor: pointer;
  }
  .labelDescription {
    display: block;
    font-weight: normal;
  }
</style>
